export default "__VITE_ASSET__NOz1dyPp__"